import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import { useFavorites } from '@/hooks/useFavorites';

export default function FavoritesMenu() {
  const { favorites } = useFavorites();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const favoriteComics = comics.filter((comic) => favorites.includes(comic.id));

  return (
    <div className="relative" ref={wrapperRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="我的收藏"
        className="relative flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
      >
        <i className="ri-heart-3-line text-lg"></i>
        {favoriteComics.length > 0 && (
          <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary-500 px-1 text-[10px] font-bold text-background-50">
            {favoriteComics.length}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-12 z-50 w-72 rounded-lg border border-background-200 bg-background-50 p-3">
          <div className="mb-2 flex items-center justify-between">
            <span className="text-sm font-bold text-foreground-950">我的收藏</span>
            <span className="text-xs text-foreground-400">{favoriteComics.length} 部</span>
          </div>
          {favoriteComics.length === 0 ? (
            <p className="rounded-md bg-background-100 px-3 py-4 text-center text-xs leading-relaxed text-foreground-500">
              还没有收藏的漫画，去详情页点击
              <i className="ri-heart-3-line mx-1 text-primary-500"></i>
              就能收藏啦
            </p>
          ) : (
            <ul className="flex max-h-72 flex-col gap-1 overflow-y-auto">
              {favoriteComics.map((comic) => (
                <li key={comic.id}>
                  <Link
                    to={`/detail/${comic.id}`}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
                  >
                    <span className="h-14 w-11 shrink-0 overflow-hidden rounded-md bg-background-100">
                      <img
                        src={comic.cover}
                        alt={comic.title}
                        className="h-full w-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="line-clamp-1 block text-sm font-medium text-foreground-900">
                        {comic.title}
                      </span>
                      <span className="line-clamp-1 block text-xs text-foreground-500">
                        {comic.latestChapter}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}